import React from "react";
import { Helmet } from "react-helmet-async";
import Edit, { Columns } from "../../component/Edit";
import { changePassword, getMyProfile, saveUser, type UserData } from "../../api/admin";
import Toast from "../../component/toast";
import { CancelablePromise } from "../../util/client";
import { useCrumbs } from "../../component/breadcrumbs";
import useLocale from "../../util/i18n";
import { usePayload } from "../../util/token";

export default function Me() {
    const {0: __} = useLocale();
    const {0: setCrumbs} = useCrumbs();
    const {0: payload, 2: logout} = usePayload();
    let columns = React.useMemo<Columns>(() => ({
        [__('General')]: [
            {
                name: 'username',
                required: true,
                label: __('Username')
            },
            {
                name: 'email',
                type: 'email',
                label: __('Email Address')
            },
            {
                name: 'info[nickname]',
                label: __('Nickname')
            // },
            // {
            //     name: 'info[avatar]',
            //     label: __('Avatar'),
            //     type: 'image'
            }
        ],
        [__('Password')]: [
            {
                name: 'password',
                type: 'password',
                label: __('Password'),
                minLength: 6
            },
            {
                name: 'rpassword',
                type: 'password',
                label: __('Repeat Password'),
                minLength: 6
            },
        ]
    }), [__]);
    const doLoad = React.useCallback((params: Record<string, any>) => {
        let p = getMyProfile();
        return new CancelablePromise<UserData>((resolve, reject) => p.then(response => {
            if (typeof response !== 'string') {
                resolve(response);
            } else {
                reject(response);
            }
        }), p.doCancel);
    }, []);
    const doSave = React.useCallback(async (data: FormData) => {
        data.set('id', payload!.admin.toString());
        if (!data.get('info[nickname]')) {
            data.delete('info[nickname]');
        }
        if (!data.get('info[avatar]')) {
            data.delete('info[avatar]');
        }
        let message: string, final = () => { };
        try {
            message = (await saveUser(data) as any).message;
            if (data.get('password')) {
                if (data.get('password') !== data.get('rpassword')) {
                    Toast.show(__('The entered passwords are different.'), 'danger');
                    return;
                }
                await changePassword({ password: data.get('password') as string });
                message = __('The password has been reset. Please login again.');
                final = logout;
            }
            Toast.show(message, 'success').then(final);
        } catch (error: any) {
            Toast.show(error, 'danger');
        }
    }, [payload, __, logout]);
    React.useEffect(() => {
        setCrumbs(['My Profile']);
    }, []);
    return (
        <>
            <Helmet>
                <title>{__('My Profile')}</title>
            </Helmet>
            <Edit columns={columns} doLoad={doLoad} doSave={doSave} />
        </>
    );
}
